/* 布局 */
//前台
import Layout from "@views/layout";

const attachmentcateRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "attachmentcate/list",
        name: "ATTACHMENTCATE",
        meta: {
            title: "",
        },
        component: () => import("@views/business/attachmentcate/index.vue"),
    },
        ],
};

export default attachmentcateRouter;
